<div
    class="agpr-coverageInsight"
    [agprLoading]="loading"
>
    <div class="agpr-coverageInsight-left agpr-coverageInsight-section" [id]="id + '.left.Section'">
        <div class="agpr-coverageInsight-sectionHeading agpr-coverageInsight-sectionHeadingContainer">
            {{ "Reports.coverageInsight.source" | localize }}
        </div>
        <div class="agpr-coverageInsight-sourcePicker">
            <agpr-chart-drilldown-source-picker
                [id]="id + '_source_picker'"
                [(ngModel)]="drilldownSeries"
                (ngModelChange)="sourceChanged($event)"
            ></agpr-chart-drilldown-source-picker>
        </div>
        <div class="agpr-coverageInsight-dateRangeSelector">
            <label
                class="agpr-coverageInsight-dateRangeSelector-label"
                [id]="id + '_dateQuery'"
            >
                {{ 'Reports.coverageInsight.dateQuery.label' | localize}}
            </label>
            <agpr-date-query-popup
                [ariaLabelledBy]="id + '_dateQuery'"
                [options]="dateOptions"
                [(ngModel)]="dateQuery"
                [searchRange]="searchRange"
                (ngModelChange)="dateRangeChanged()"
            >
            </agpr-date-query-popup>
        </div>
        @if(mentionCount > errorMentionCount) {
            <div
                [id]="id + '.thresholdMessage'"
                class="agpr-coverageInsight-mentionCountInfo"
            >
                <agpr-message
                    [id]="id + '.message.error'"
                    [severity]="messageSeverityEnum.error"
                >
                    {{ 'Reports.coverageInsight.mentionCountInfo.lessThanThreshold' | localize: {total: mentionCount} }}
                    <br>
                    {{ 'Reports.coverageInsight.mentionCountInfo.error' | localize }}
                </agpr-message>
            </div>
        } @else if (mentionCount > warningMentionCount) {
            <div
                [id]="id + '.thresholdMessage'"
                class="agpr-coverageInsight-mentionCountInfo"
            >
                <agpr-message
                    [id]="id + '.message.warning'"
                    [severity]="messageSeverityEnum.warning"
                >
                    {{ 'Reports.coverageInsight.mentionCountInfo.lessThanThreshold' | localize: {total: mentionCount} }}
                    <br>
                    {{ 'Reports.coverageInsight.mentionCountInfo.warning' | localize }}
                </agpr-message>
            </div>
        }
        @else {
            <div
                [id]="id + '.thresholdMessage'"
                class="agpr-coverageInsight-mentionCountInfo"
            >
                <agpr-message
                    [id]="id + '.message.info'"
                    [severity]="messageSeverityEnum.info"
                >
                    {{ 'Reports.coverageInsight.mentionCountInfo.lessThanThreshold' | localize: {total: mentionCount} }}
                </agpr-message>
            </div>
        }
        @if(keyMessageGroups?.length) {
            <div
                class="agpr-coverageInsight-keyMessages"
            >
                <div class="agpr-coverageInsight-keyMessages-label">
                    {{ "Reports.coverageInsight.keyMessages" | localize }}
                </div>
                <agpr-scroll-panel
                    #keyMessageScrollPanel
                    [id]="id + '.keyMessages.scrollPanel'"
                >
                    <div class="agpr-coverageInsight-keyMessages-cardContainer">
                        @for (keyMessageGroup of keyMessageGroups; track $index) {
                            <div
                                class="agpr-coverageInsight-keyMessages-card"
                                [ngClass]="{
                                    'agpr-coverageInsight-keyMessages-card--selected': keyMessageGroup.selected
                                }"
                                (click)="selectKeyMessage(keyMessageGroup)"
                            >
                                <div class="agpr-coverageInsight-keyMessages-card-content">
                                    <div class="agpr-coverageInsight-keyMessages-card-title">{{ keyMessageGroup.keyMessageGroupTitle }}</div>
                                    <div class="agpr-coverageInsight-keyMessages-card-summary">{{ keyMessageGroup.keyMessageGroupSummary }}</div>
                                </div>
                            </div>
                        }

                        @if(showBackButton) {
                            <div class="agpr-coverageInsight-keyMessages-backButton">
                                <agpr-button
                                label="Reports.coverageInsight.backToAnalysis"
                                (click)="backToAnalysis()"
                                [style]="buttonTypes.tertiary"
                            ></agpr-button>
                            </div>
                        }
                    </div>
                </agpr-scroll-panel>
            </div>
        }
        @if (keyMessageGroups?.length) {
            <div
                class="agpr-coverageInsight-left-userDefinedKeyMessage"
                [@toggleContent]="{ value: collapsed ? 'collapsed' : 'expand', params: { height: '35px' } }"
                (@toggleContent.done)="onToggleDone()"
            >
                <div class="agpr-coverageInsight-userDefinedMessage">
                    <div
                        class="agpr-coverageInsight-userDefinedMessage-header"
                    >
                        {{ 'Reports.coverageInsight.userDefinedMessage.header' | localize }}
                    </div>
                    @if (!collapsed) {
                        <agpr-textarea-input
                            [id]="id + '_userDefinedMessage_textArea'"
                            label="Reports.coverageInsight.userDefinedMessage.description"
                            [rows]="4"
                            [placeholder]="'Reports.coverageInsight.userDefinedMessage.placeholder' | localize"
                            [(ngModel)]="userDefinedKeyMessageString"
                        ></agpr-textarea-input>
                        <div
                            class="agpr-coverageInsight-userDefinedMessage-buttonContainer"
                        >
                            <agpr-button
                                [id]="id + '_userDefinedMessage_applyButton'"
                                label="Reports.coverageInsight.userDefinedMessage.button"
                                [disabled]="!userDefinedKeyMessageString?.trim()"
                                [style]="buttonTypes.tertiary"
                                (click)="applyUserDefinedKeyMessage()"
                            ></agpr-button>
                        </div>
                    }
                    <span
                        class="fa-solid agpr-expandToggle agpr-coverageInsight-userDefinedMessage-expandToggle agpr-coverageInsight-userDefinedMessage-expandToggle--left"
                        [ngClass]="collapsed ? 'fa-angle-up' : 'fa-angle-down'"
                        [id]="id + '.userDefinedMessage.expandToggle'"
                        (click)="toggle($event)"
                    >
                    </span>
                </div>
            </div>
        }
    </div>
    @if (!keyMessageGroups?.length) {
        <div
            class="agpr-coverageInsight-section agpr-coverageInsight-dashboard" [id]="id + '.dashboard.section'"
        >
            <div class="agpr-coverageInsight-infoCard">
                <div class="agpr-coverageInsight-infoCard-icon">
                    <span
                        aria-hidden="true"
                        class="fa-kit-duotone fa-agpr-insights"
                    ></span>
                </div>
                <div
                    class="agpr-coverageInsight-infoCard-header"
                    [innerHTML]="'Reports.coverageInsight.promotion.heading' | localize "
                >
                </div>
                <div class="agpr-coverageInsight-infoCard-text">
                    {{ 'Reports.coverageInsight.promotion.text' | localize }}
                </div>
                <div class="agpr-coverageInsight-addContext-container">
                    <div class="agpr-coverageInsight-addContext-description">
                        {{ 'Monitor.MAD.coverageInsights.addContext.description' | localize }}
                    </div>
                    <agpr-textarea-input
                        class="agpr-coverageInsight-addContext-textareaInput"
                        [id]="'coverageInsight_addContext_textarea'"
                        placeholder="Monitor.MAD.coverageInsights.addContext.placeholder"
                        [(ngModel)]="analysisContext"
                        [rows]="5"
                        [icon]="'fa-kit-duotone fa-agpr-ai-generic'"
                    ></agpr-textarea-input>
                </div>
                <div class="agpr-coverageInsight-infoCard-button">
                    <agpr-button
                        label="Reports.coverageInsight.promotion.button"
                        id="drilldownAnalyzeCoverage"
                        (click)="analyzeCoverage($event)"
                        [style]="buttonTypes.primary"
                        [disabled]="mentionCount <= 0"
                        [tailIcon]="hasCoverageInsightsEnabled ? '' : 'fa-kit-duotone fa-agpr-upgrade'"
                    ></agpr-button>
                </div>
            </div>
            <div class="agpr-coverageInsight-spacer"></div>
            @if (hasCoverageInsightsEnabled) {
                <div
                    class="agpr-coverageInsight-userDefinedMessageContainer"
                    [@toggleContent]="collapsed ? 'collapsed' : 'expand'"
                    (@toggleContent.done)="onToggleDone()"
                >
                    <div class="agpr-coverageInsight-userDefinedMessage">
                        @if(collapsed) {
                            <div
                                class="agpr-coverageInsight-userDefinedMessage-info"
                            >
                                {{ 'Reports.coverageInsight.userDefinedMessage.info' | localize }}
                            </div>
                        }
                        <div
                            class="agpr-coverageInsight-userDefinedMessage-header"
                        >
                            {{ 'Reports.coverageInsight.userDefinedMessage.header' | localize }}
                        </div>

                        @if (!collapsed) {
                            <agpr-textarea-input
                                [id]="id + '_userDefinedMessage_textArea'"
                                label="Reports.coverageInsight.userDefinedMessage.label"
                                [rows]="4"
                                [placeholder]="'Reports.coverageInsight.userDefinedMessage.placeholder' | localize"
                                [(ngModel)]="userDefinedKeyMessageString"
                            ></agpr-textarea-input>
                            <div
                                class="agpr-coverageInsight-userDefinedMessage-buttonContainer"
                            >
                                <agpr-button
                                    [id]="id + '_userDefinedMessage_applyButton'"
                                    label="Reports.coverageInsight.userDefinedMessage.button"
                                    [style]="buttonTypes.tertiary"
                                    [disabled]="!userDefinedKeyMessageString?.trim()"
                                    (click)="applyUserDefinedKeyMessage()"
                                ></agpr-button>
                            </div>
                        }
                        <span
                            [id]="id + '.userDefinedMessage.expandToggle'"
                            class="fa-solid agpr-expandToggle agpr-coverageInsight-userDefinedMessage-expandToggle"
                            [ngClass]="collapsed ? 'fa-angle-up' : 'fa-angle-down'"
                            (click)="toggle($event)"
                        >
                        </span>
                    </div>
                </div>
            }
        </div>
    } @else {
        <div
            class="agpr-coverageInsight-section agpr-coverageInsight-mentions"
            [agprLoading]="loadingMentions"
            [id]="id + '.mentions.section'"
        >
            <div class="agpr-coverageInsight-sectionHeadingContainer">
                <div class="agpr-coverageInsight-sectionHeading">
                    {{ "Reports.coverageInsight.mentionSamples" | localize }}
                </div>
                <span
                    role="img"
                    class="agpr-coverageInsight-tooltip fa-regular fa-circle-info"
                    [agprTooltip]="'Reports.coverageInsight.mentionSamples.tooltip' | localize"
                ></span>
            </div>

            <div class="agpr-coverageInsight-mentions-toolbar">
                <span class="agpr-coverageInsight-mentions-toolbar-selectToggle">
                    <agpr-checkbox
                        [id]="id + 'mentions_toolbar_selectToggle'"
                        [label]="selectedMentionCount"
                        [disabled]="!mentions?.length"
                        [binary]="true"
                        [pTooltip]="(selectedMentionCount > 0 ? 'Monitoring.result.selectNone' : 'Monitoring.result.selectAll') | localize"
                        hiddenLabel="Monitoring.result.selectAll"
                        [ngModel]="!!selectedMentionCount"
                        (ngModelChange)="toggleSelectAll()"
                    ></agpr-checkbox>
                </span>
                <div class="agpr-coverageInsight-mentions-toolbar-folderSelector">
                    <agpr-autocomplete
                        [id]="id + 'mentions_toolbar_folderSelector'"
                        labelField="name"
                        placeholder="Monitoring.folderPicker.placeholder"
                        [dropdown]="true"
                        [(ngModel)]="selectedFolder"
                        (clear)="selectedFolder = null"
                        [customOptions]="folderAutocompleteOptions"
                        [suggestions]="folderList$"
                        [clearOnBlur]="false"
                        [ariaLabel]="'Monitoring.folderPicker.tooltip'"
                        [showHiddenOption]="true"
                    ></agpr-autocomplete>
                </div>
                <div class="agpr-coverageInsight-mentions-toolbar-applyButton">
                    <agpr-button
                        [id]="id + 'mentions_toolbar_applyButton'"
                        [label]="'Monitoring.result.saveMentions' | localize"
                        [style]="buttonTypes.tertiary"
                        [disabled]="!mentions?.length || selectedMentionCount < 1 || saveInProgress"
                        (click)="saveSelectedMentions()"
                    ></agpr-button>
                </div>
            </div>
            <agpr-scroll-panel
                #mentionScrollPanel
                [id]="id + '.mentions.scrollPanel'"
            >
                <div class="agpr-coverageInsight-mentions-cards">
                    <ul>
                        <li *ngFor="let mention of mentions; let i = index">
                            <agpr-coverage-insight-mention-card
                                class="agpr-coverageInsight-mentionCard"
                                [mention]="mention"
                                [index]="i"
                                (mentionSelectChange)="mentionSelectChange()"
                                (contactClicked)="mentionCardClicked({ eventType: 'contact', mention: mention })"
                                (outletClicked)="mentionCardClicked({ eventType: 'outlet', mention: mention })"
                                (manageMention)="openManageMentionOrganizationDialog(mention)"
                                (viewMention)="mentionCardClicked({ eventType: 'mention', mention: mention })"
                                (click)="mentionCardClicked({ eventType: 'mention', mention: mention })"
                            >
                            </agpr-coverage-insight-mention-card>
                        </li>
                    </ul>
                    @if(!mentions?.length) {
                        <div class="agpr-coverageInsight-mentions-noContent">
                            <agpr-message
                                [severity]="messageSeverityEnum.noContent"
                            >
                                {{ 'Monitoring.result.noMentionsFound' | localize }}
                            </agpr-message>
                        </div>
                    }
                </div>
            </agpr-scroll-panel>
        </div>
    }


    @if (keyMessageGroups?.length) {
        <div
            class="agpr-coverageInsight-section agpr-coverageInsight-insights" [id]="id + '.insights.section'"
        >
            <div class="agpr-coverageInsight-sectionHeading agpr-coverageInsight-sectionHeadingContainer">
                {{ "Reports.coverageInsight.insights" | localize }}
            </div>

            <div class="agpr-coverageInsight-languageSelector-container">
                <h4
                    id="coverageInsight_languageSelector_label"
                    class="agpr-coverageInsight-languageSelector-heading"
                >
                    {{ 'Mention.insightsExplorerTab.quickInsights.languageSelector.label' | localize }}
                </h4>

                <div class="agpr-coverageInsight-languageSelector">
                    <agpr-dropdown
                        [id]="'coverageInsight_lanaguageSelector-dropdown'"
                        [options]="promptLanguageOptions"
                        ariaLabelledBy="coverageInsight_languageSelector_label"
                        [(ngModel)]="selectedLanguage"
                    ></agpr-dropdown>
                </div>
            </div>
            <agpr-scroll-panel
                #promptScrollPanel
                [id]="id + '.prompt.scrollPanel'"
            >
                <ul class="agpr-coverageInsight-prompt-container">
                    @for (prompt of prompts; track $index) {
                        <li
                            class="agpr-coverageInsight-promptListItem"
                        >
                            <agpr-insight-card
                                [id]="prompt.type + '_insightCard'"
                                [label]="'Reports.coverageInsight.insights.' + prompt.type"
                                [isEmpty]="!(prompt.insightText || prompt.insightModel)"
                                [isPromptGenerating]="prompt.generating"
                                [collapseOnCancel]="!prompt.keywords"
                                [infoCircleTooltip]="'Reports.coverageInsight.insights.tooltip.' + prompt.type"
                                [saved]="false"
                                [preLabelIcon]="true"
                                [generateDisabled]="!mentions?.length"
                                (generate)="generateInsight(prompt)"
                                (stopGeneration)="cancelGeneration(prompt)"
                            >
                                @if (prompt?.type === aiAnalysisTypes.COVERAGE_INSIGHT_CONTEXTUAL_ANALYSIS) {
                                    <div class="agpr-coverageInsight-promptFields">
                                        <agpr-text-input
                                            [id]="prompt.type + '_insightCard_context'"
                                            [label]="'Reports.coverageInsight.prompt.context'"
                                            [placeholder]="'Reports.coverageInsight.prompt.context.placeholder'"
                                            [disabled]="prompt.generating"
                                            [bottomMargin]="false"
                                            [(ngModel)]="prompt.context"
                                        ></agpr-text-input>
                                        @if (!prompt.context) {
                                            <agpr-form-message>
                                                {{ 'Reports.coverageInsight.prompt.context.error' | localize }}
                                            </agpr-form-message>
                                        }
                                    </div>
                                }

                                @if (prompt?.type === aiAnalysisTypes.COVERAGE_INSIGHT_BRAND_IMPACT) {
                                    <div class="agpr-coverageInsight-promptFields">
                                        <agpr-text-input
                                            [id]="prompt.type + '_insightCard_brand'"
                                            [label]="'Reports.coverageInsight.prompt.brand'"
                                            [disabled]="prompt.generating"
                                            [bottomMargin]="false"
                                            [placeholder]="'Reports.coverageInsight.prompt.brand.placeholder'"
                                            [(ngModel)]="prompt.brand"
                                        ></agpr-text-input>
                                        @if (!prompt.brand) {
                                            <agpr-form-message>
                                                {{ 'Reports.coverageInsight.prompt.brand.error' | localize }}
                                            </agpr-form-message>
                                        }
                                    </div>
                                }

                                @if (prompt?.type === aiAnalysisTypes.COVERAGE_INSIGHT_SENTIMENT_OPINION) {
                                    <div class="agpr-coverageInsight-promptFields">
                                        <agpr-text-input-chips
                                            [id]="prompt.type + '_insightCard_keywords'"
                                            [disabled]="prompt.generating"
                                            header="Reports.coverageInsight.prompt.context"
                                            placeholder="Reports.coverageInsight.prompt.context.placeholder"
                                            [(ngModel)]="prompt.keywords"
                                        ></agpr-text-input-chips>
                                    </div>
                                }

                                <div class="agpr-coverageInsight-promptActionButton">
                                        <agpr-button
                                            [id]="prompt.type + '_generateButton'"
                                            class="agpr-coverageInsight-generateButton"
                                            [label]="prompt.insightText ? 'Reports.coverageInsight.prompt.regenerate' :  'Reports.coverageInsight.prompt.generate'"
                                            [style]="buttonTypes.tertiary"
                                            [disabled]="prompt.generating"
                                            (click)="generateInsight(prompt)"
                                        ></agpr-button>
                                </div>

                                @if (!!(prompt.insightText) && !prompt.noContentGenerated) {
                                    <div
                                        class="agpr-coverageInsight-prompt-content"
                                    >
                                        <div
                                            [innerHTML]="prompt.insightText | setUlStyle | sanitizeHtml"
                                        ></div>
                                    </div>
                                }
                                @if(prompt.noContentGenerated) {
                                    <agpr-message
                                        class="agpr-coverageInsight-noContentMessage"
                                        [severity]="messageSeverityEnum.noContent"
                                    >
                                        {{ prompt.insightText }}
                                    </agpr-message>
                                }
                            </agpr-insight-card>
                        </li>
                    }
                </ul>
            </agpr-scroll-panel>
        </div>
    }
</div>
